module.exports = __webpack_public_path__ + "static/media/day_six.18449d34.jpg";